const getOffsetTop = (element) => {
  const firstChildOfBody = document.getElementsByTagName('body')[0];
  let currentEl = element;
  let offsetTop = currentEl.offsetTop;

  while (currentEl.offsetParent && currentEl !== firstChildOfBody) {
    offsetTop += currentEl.offsetParent.offsetTop;
    currentEl = currentEl.offsetParent;
  }

  return offsetTop;
};

const scrollViewTo = ({ id, offset }) => {
  console.log(arguments);
  const element = document.getElementById(id);
  if (element) {
    window.scrollTo(0, getOffsetTop(element) - (offset || 0));
  }
};

export default scrollViewTo;



/** WEBPACK FOOTER **
 ** ./src/util/scrollViewTo.js
 **/